export default __webpack_public_path__ + "72b0f662c89a3b8b6edc09a47c3175e6.png";